import React from 'react';
import { Phone, CheckCircle2, Shield, Award } from 'lucide-react';
import LeadCaptureForm from './LeadCaptureForm';

const NewHero = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-32 pb-16 px-4 overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_garage-rate-finder/artifacts/op2z7yv5_a0c5a971-5b2b-4ea7-a8ac-dacb6a19dd87-1.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/90 to-slate-900/80"></div>
      </div>
      
      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="text-white">
            <div className="inline-flex items-center gap-2 bg-emerald-600/20 backdrop-blur-sm border border-emerald-500/30 text-emerald-300 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Award className="h-4 w-4" />
              <span>Licensed & Insured • Winter Park's Most Trusted</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              Most Trusted Garage Cleaning & Organization in Winter Park
            </h1>
            
            <p className="text-xl md:text-2xl text-slate-200 mb-8 leading-relaxed">
              Ready for a meticulously organized garage? We provide professional garage cleaning and organization services in Winter Park & the Greater Orlando area. Get more free time for the things you love!
            </p>
            
            {/* Trust Badges */}
            <div className="grid grid-cols-3 gap-4 mb-8">
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
                <CheckCircle2 className="h-8 w-8 text-emerald-400 mb-2" />
                <div className="text-sm font-semibold">100% Satisfaction Guaranteed</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
                <Shield className="h-8 w-8 text-emerald-400 mb-2" />
                <div className="text-sm font-semibold">Licensed & Insured</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
                <Award className="h-8 w-8 text-emerald-400 mb-2" />
                <div className="text-sm font-semibold">Background Checked Team</div>
              </div>
            </div>
            
            <div className="flex items-center gap-4 mb-6">
              <div className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-emerald-400" />
                <a href="tel:386-283-0286" className="text-2xl font-bold hover:text-emerald-400 transition-colors">
                  386-283-0286
                </a>
              </div>
            </div>
            
            <p className="text-sm text-slate-300">
              Serving Winter Park, Orlando, Maitland, Altamonte Springs & surrounding areas
            </p>
          </div>
          
          {/* Right Column - Lead Capture Form */}
          <div>
            <LeadCaptureForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewHero;